module.exports = __webpack_public_path__ + "img/prob.ad8eb896.png";